(function ($) {

    $.fn.togglePassword = function (options) {
        var opts = $.extend(true, {}, $.fn.togglePassword.defaults, options);
        try {
            return this.each(function () {
                new initialize($(this), opts);
            });
        } catch (error) {
            log(error);
        }
    };
    
    $.fn.togglePassword.defaults = {
        icon: 'fa-eye',
        iconHide: 'fa-eye-slash',
        hideText: '',
        showText: ''
    };

    function initialize(element, options) {
        var parent = element.parent();
        parent.addClass("sp-toggle-pass");

        var btn = $('<a href="#" class="btn-toggle-pass" tabindex="-1"><i class="fa"></i></a>');
        element.after(btn);

        $(btn).data("options", options);
        $(btn).data("inputElement", element);

        init(btn, element);
    }


    function init(btn, element) {
        //element.css("border-right", "0");
        switchButton(btn, false);
        bindEvents(btn, element);
    }

    function switchButton(element, hide) {
        var options = $(element).data("options");
        var icon = $(element).find("i");
        if (hide === true) {
            $(element).attr("Title", options.hideText);
            $(icon).removeClass(options.iconHide);
            $(icon).addClass(options.icon);
        } else {
            $(element).attr("Title", options.showText);
            $(icon).removeClass(options.icon);
            $(icon).addClass(options.iconHide);
        }
    }

    function bindEvents(btn, element) {
        btn.on('click', handleClick);
        element.on('focusin', function() {
            btn.addClass("sp-focus");
        });
        element.on('focusout', function() {
            btn.removeClass("sp-focus");
        });
    }

    function handleClick(e) {
        e.preventDefault();
        var inputElement = $(this).data("inputElement");

        var type = $(inputElement).attr('type');

        type = type === 'password' ? 'text' : 'password';

        $(inputElement).attr('type', type);
        var hide = type === 'password' ? false : true;
        switchButton($(this), hide);
    }

    function log(message) {
        window.console && console.log("Toggle password: " + message);
    }
})(jQuery);